export interface PrizmContextWithImplicit<T> {
  $implicit: T;
}
